import React from 'react';

export default class Sospechoso extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount(){}

  render(){
    const {show, editar, datos} = this.props;
    return(
      <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
        <div style={{
          display:'flex', flexDirection:'row', width:'calc(100% - 30px)',
          padding:'10px 15px', backgroundColor:'#00b1e9', color:'white',
          fontSize:18, fontFamily:'Barlow_Condensed', fontWeight:'bold'
        }}>
          <strong>6. </strong> &nbsp;
          ¿Es caso sospechoso de COVID-19?
        </div>
        <div style={{
          display: show ? 'flex' : 'none',
          flexDirection:'column', width:'100%', margin:'10px 0'
        }}>
          <label style={{display:'block'}}>
            <input
              type="checkbox"
              style={{minWidth:30}}
              checked={datos.sospechoso}
              onChange={(e) => editar('sospechoso', e.target.checked)}
            />
            Si
          </label>
          <label style={{display:'block'}}>
            <input
              type="checkbox"
              style={{minWidth:30}}
              checked={!datos.sospechoso}
              onChange={(e) => editar('sospechoso', !e.target.checked)}
            />
            No
          </label>
          {datos.sospechoso &&
            <span style={{margin:3}}>
              Recordar medidas generales de prevención
            </span>
          }
        </div>
      </div>
    )
  }
}
